// import axios from "axios";

// require("!style-loader!css-loader!../xrextras/fonts/fonts.css");
// require("!style-loader!css-loader!../xrextras/translationmodule/translation-module.css");

// // const html = require('html-loader!../xrextras/translationmodule/translation-module.html');

// // New Event name
// const custom_event = new Event("lan-selected");

// // Require the languages
// const cn_translation = require("../languages/cn").default;

// // Add them to the index
// const languages_index: any = {
//   cn: {
//     data: cn_translation
//   },
// };

// let translationModule: any = null;
// let translationMode: any = null;

// function create() {
//   const rootElementNode: any = null;

//   // const injectElements = () => {
//   //   const e = document.createElement('template');
//   //   e.innerHTML = html.trim();
//   //   rootElementNode = e.content.firstChild;
//   //   document.getElementsByTagName('body')[0].appendChild(rootElementNode);
//   // }

//   const setMode = (mode: any) => {
//     translationMode = mode;
//   };

//   const detectCountry = () => {
//     return new Promise((resolve, reject) => {
//       // resolve({country: "CN"});
//       axios.get("https://ipinfo.io?token=726a0a41befbc5")
//       .then((res) => {
//         resolve(res.data);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//     });
//   };

//   const translate = (translate_data: any) => {
//     const page_translations = languages_index[translate_data.country.toLowerCase()];
//     if (page_translations !== undefined) {
//       page_translations.data.forEach((obj: any) => {
//         const el = document.querySelector(`#${obj.element_id}`);
//         if (obj["text"] !== undefined) {
//           el!.innerHTML = obj.text;
//         } else if (obj["src"] !== undefined) {
//           (el as any)!.src = obj.src;
//         }
//       });
//     }
//   };

//   const showLanguageSelector = () => {
//     // Show the selector.
//     rootElementNode.style.display = "block";
//     const selectButton = rootElementNode.querySelector("#lanSelected");

//     selectButton.addEventListener("click", (e: any) => {
//       document.dispatchEvent(custom_event);
//     });

//     document.addEventListener("lan-selected", (e) => {
//       hideLanguageSelector();
//     });
//   };

//   const hideLanguageSelector = () => {
//     rootElementNode.style.display = "none";
//   };

//   return {
//     // injectElements,
//     detectCountry,
//     translate,
//     showLanguageSelector,
//     hideLanguageSelector,
//     setMode,
//     translationMode,
//   };
// }

// const TranslationFactory = () => {
//   if (!translationModule) {
//     translationModule = create();
//   }

//   return translationModule;
// };

// export { TranslationFactory };

import axios from "axios";

export const detectCountry = () => {
  return new Promise((resolve, reject) => {
    // resolve({country: "CN"});
    axios
      .get("https://ipinfo.io?token=726a0a41befbc5")
      .then((res: any) => {
        resolve(res.data);
      })
      .catch((err: any) => {
        reject(err);
      });
  });
};

// Service used https://ipinfo.io/
